import React, { ReactNode } from "react";
import { style, classes } from "typestyle";
import { vSpaced } from "../../../../cssUtils";

interface CardProps {
  children: ReactNode;
}

const Card = ({ children }: CardProps) => (
  <div
    className={classes(
      style(vSpaced(16)),
      style({
        background: "#FFFFFF",
        boxShadow:
          "0px 2px 2px rgba(0, 0, 0, 0.24), 0px 0px 2px rgba(0, 0, 0, 0.12)",
        borderRadius: "12px",
        padding: "32px 25px",
      }),
    )}
  >
    {children}
  </div>
);

export default Card;
